<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_ix"></a><a id="frontmatter01"></a>ACKNOWLEDGMENTS</h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"> </p>
<p class="para">Thanks to my stellar agent, Deidre Knight, and the smart, savvy ladies of the Knight Agency, whose advice and support are indispensable. To my incomparable editor, Rose Hilliard, for her championship through the launch of this series. Also to Jeanne Devlin, my tireless and energetic publicist, for her incredible work and help. These women all routinely go so far above and beyond the call of duty that it’s hard to imagine what my career would look like without them. I suspect it would be pretty bleak. So thanks!!</p>
<p class="para"> </p>
<p class="para">The first draft of this book would never have been finished without the cheerleading (and butt-kicking, when I needed it) from a very special group of women: the Queens of Peen. You know who you are, and you know I appreciated every second of it. Extra thanks go to my duo of muses, Kristen Painter and Roxanne St. Claire—you make every day of sitting alone in front of my computer feel like a party! I adore you guys.</p>
<p class="para"> </p>
<p class="para">My family gets special mention for this book because many of the dishes mentioned come straight from my childhood. My mother even helped perfect the already-perfect recipe for Delmonico Pudding, which appears in the back of the book! Other recipe-testing thanks go to the lovely Megan <a id="page_x"></a>Blocker, home cook par excellence and food blogger extraordinaire.</p>
<p class="para"> </p>
<p class="para">And, as always, the biggest thank you of all to my husband, Nick, who never flags, never wavers, and never complains when I serve him frozen pizza for the fifth night in a row while I’m on deadline. Beta reader, sounding board, best friend, and love of my life all wrapped up in one tall, delicious package. I’m truly the luckiest woman in the world!</p>
<p class="para"> </p>
<p class="para">It’s wonderful to have so much support and help as I write—if this book is any good at all, it’s thanks to all of you. Any mistakes are mine alone.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?02aa770c